// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--2zXLw","footer":"Layout-module--footer--1Quzd"};